import auth from "./auth"

const realAPI = { auth }

export default realAPI
